/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState, useCallback } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";
import getCroppedImg from "../../utils/cropImage";
import { CropperWrapper } from "../../utils/CropperWrapper";
import ImageUploader from "../../utils/ImageUploader";

// CD34 — KD46500/600 WHITE BABY 330x333
// Pozycje tekstów (style inline, w mm):
//   top   = górna krawędź pola tekstowego
//   left  = środek tekstu (textAlign center + translateX(-50%)) albo lewa krawędź (textAlign left)
//   right = prawa krawędź pola (textAlign right)
// maxWidthN = maks. szerokość tekstu w px — dłuższy tekst zmniejsza czcionkę.
// Uwaga: lineHeight w stylu InlineEdit nie działa (nadpisuje go `font: inherit`), zawsze wynosi 1.5.
export const Cd34: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("ANTOŚ");
  const [text2, setText2] = useState<string>("6");
  const [text3, setText3] = useState<string>("KWIETNIA");
  const [text4, setText4] = useState<string>("2021");
  const [text5, setText5] = useState<string>("godzina");
  const [text6, setText6] = useState<string>("6:40");
  const [text7, setText7] = useState<string>("3660 g");
  const [text8, setText8] = useState<string>("miłości");
  const [text9, setText9] = useState<string>("59 cm");
  const [text10, setText10] = useState<string>("szczęścia");
  const text1BasicSize = 153;
  const text2BasicSize = 35;
  const text3BasicSize = 35;
  const text4BasicSize = 35;
  const text5BasicSize = 36;
  const text6BasicSize = 47;
  const text7BasicSize = 38;
  const text8BasicSize = 38;
  const text9BasicSize = 38;
  const text10BasicSize = 30;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const [fontSizeText7, setFontSizeText7] = useState<number>(text7BasicSize);
  const [fontSizeText8, setFontSizeText8] = useState<number>(text8BasicSize);
  const [fontSizeText9, setFontSizeText9] = useState<number>(text9BasicSize);
  const [fontSizeText10, setFontSizeText10] = useState<number>(text10BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();
  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");

  const pdfWidth = "330mm"; // PDF width in mm
  const pdfHeight = "333mm"; // PDF height in mm
  const font1 = "Caveatbrush";
  const font2 = "Margarine-Regular";
  const maxWidth1 = 515;
  const maxWidth2 = 96;
  const maxWidth3 = 221;
  const maxWidth4 = 153;
  const maxWidth5 = 199;
  const maxWidth6 = 170;
  const maxWidth7 = 196;
  const maxWidth8 = 196;
  const maxWidth9 = 176;
  const maxWidth10 = 204;
  // Okno na zdjęcie użytkownika
  const photoTop = "77.1mm";
  const photoLeft = "95.7mm";
  const photoWidth = "128.6mm";
  const photoHeight = "139.4mm";
  const photoAspect = 128.6 / 139.4;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
    fontFamily: string,
    maxWidth: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px ${fontFamily}`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  // Czekamy na załadowanie fontu, inaczej canvas mierzy tekst fontem zastępczym.
  const ensureFont = (fontFamily: string) => document.fonts.load(`1em ${fontFamily}`);

  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 14, font1, maxWidth1))
    );
  }, [text1]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 10, font2, maxWidth2))
    );
  }, [text2]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 10, font2, maxWidth3))
    );
  }, [text3]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText4(adjustFontSize(text4, fontSizeText4, text4BasicSize, 10, font2, maxWidth4))
    );
  }, [text4]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText5(adjustFontSize(text5, fontSizeText5, text5BasicSize, 10, font2, maxWidth5))
    );
  }, [text5]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText6(adjustFontSize(text6, fontSizeText6, text6BasicSize, 14, font2, maxWidth6))
    );
  }, [text6]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText7(adjustFontSize(text7, fontSizeText7, text7BasicSize, 10, font2, maxWidth7))
    );
  }, [text7]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText8(adjustFontSize(text8, fontSizeText8, text8BasicSize, 10, font2, maxWidth8))
    );
  }, [text8]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText9(adjustFontSize(text9, fontSizeText9, text9BasicSize, 10, font2, maxWidth9))
    );
  }, [text9]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText10(adjustFontSize(text10, fontSizeText10, text10BasicSize, 10, font2, maxWidth10))
    );
  }, [text10]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      true
    );
  };

  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage = useCallback(async () => {
    if (image && croppedAreaPixels) {
      const croppedImg = await getCroppedImg(image, croppedAreaPixels);
      setCroppedImage(croppedImg);
      setStep("view");
    }
  }, [image, croppedAreaPixels]);

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
        <ImageUploader
          onImageChange={(image) => setImage(image)}
          setStep={setStep}
        />
        {step === "crop" && (
          <p>
            Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
          </p>
        )}
        <div style={{}}>
          {step !== "crop" && (
            <Button onClick={handleSave} disabled={isSaving}>
              {isSaving ? "Zapisywanie..." : "Zapisz"}
            </Button>
          )}
          {step === "crop" && (
            <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
          )}
        </div>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "Caveatbrush, Margarine-Regular",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        {/* ANTOŚ */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: font1,
            color: "#c0d1cd",
            position: "absolute",
            top: "8.6mm",
            left: "165.5mm",
            width: `${maxWidth1 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 6 */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: font2,
            color: "#606262",
            position: "absolute",
            top: "81mm",
            left: "244.8mm",
            width: `${maxWidth2 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* KWIETNIA */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: font2,
            color: "#606262",
            position: "absolute",
            top: "91.7mm",
            left: "244.8mm",
            width: `${maxWidth3 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 2021 */}
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: font2,
            color: "#606262",
            position: "absolute",
            top: "102mm",
            left: "244.7mm",
            width: `${maxWidth4 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* godzina */}
        <InlineEdit
          value={text5}
          setValue={setText5}
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: font2,
            color: "#606262",
            position: "absolute",
            top: "149.1mm",
            left: "83.5mm",
            width: `${maxWidth5 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 6:40 */}
        <InlineEdit
          value={text6}
          setValue={setText6}
          style={{
            fontSize: `${fontSizeText6}px`,
            fontFamily: font2,
            color: "#606262",
            position: "absolute",
            top: "160.2mm",
            left: "83.4mm",
            width: `${maxWidth6 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 3660 g */}
        <InlineEdit
          value={text7}
          setValue={setText7}
          style={{
            fontSize: `${fontSizeText7}px`,
            fontFamily: font2,
            color: "#606262",
            position: "absolute",
            top: "212.8mm",
            left: "116.8mm",
            width: `${maxWidth7 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "-0.3px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* miłości */}
        <InlineEdit
          value={text8}
          setValue={setText8}
          style={{
            fontSize: `${fontSizeText8}px`,
            fontFamily: font2,
            color: "#606262",
            position: "absolute",
            top: "225.4mm",
            left: "116.8mm",
            width: `${maxWidth8 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 59 cm */}
        <InlineEdit
          value={text9}
          setValue={setText9}
          style={{
            fontSize: `${fontSizeText9}px`,
            fontFamily: font2,
            color: "#606262",
            position: "absolute",
            top: "233.1mm",
            left: "168.8mm",
            width: `${maxWidth9 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* szczęścia */}
        <InlineEdit
          value={text10}
          setValue={setText10}
          style={{
            fontSize: `${fontSizeText10}px`,
            fontFamily: font2,
            color: "#606262",
            position: "absolute",
            top: "245.5mm",
            left: "168.7mm",
            width: `${maxWidth10 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />

        {/* Step: Crop */}
        {image && step === "crop" && (
          <CropperWrapper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={photoAspect}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
            style={{
              top: photoTop,
              left: photoLeft,
              width: photoWidth,
              height: photoHeight,
              transform: "none",
            }}
          />
        )}

        {/* Step: View */}
        {croppedImage && step === "view" && (
          <img
            src={croppedImage}
            alt=""
            style={{
              position: "absolute",
              top: photoTop,
              left: photoLeft,
              width: photoWidth,
              height: photoHeight,
              objectFit: "cover",
              clipPath: "polygon(96.45% 62.73%, 94.65% 66.90%, 92.51% 70.93%, 90.05% 74.81%, 87.29% 78.50%, 84.24% 81.97%, 80.93% 85.20%, 77.39% 88.16%, 73.64% 90.83%, 69.70% 93.19%, 65.62% 95.22%, 61.42% 96.91%, 57.13% 98.24%, 52.79% 99.20%, 48.42% 99.79%, 44.07% 100.00%, 39.77% 99.83%, 35.54% 99.28%, 31.42% 98.35%, 27.44% 97.06%, 23.64% 95.41%, 20.03% 93.41%, 16.65% 91.08%, 13.53% 88.44%, 10.69% 85.51%, 8.14% 82.31%, 5.91% 78.86%, 4.02% 75.19%, 2.48% 71.33%, 1.30% 67.30%, 0.49% 63.15%, 0.05% 58.90%, 0.00% 54.57%, 0.33% 50.22%, 1.03% 45.86%, 2.11% 41.53%, 3.55% 37.27%, 5.35% 33.10%, 7.49% 29.07%, 9.95% 25.19%, 12.71% 21.50%, 15.76% 18.03%, 19.07% 14.80%, 22.61% 11.84%, 26.36% 9.17%, 30.30% 6.81%, 34.38% 4.78%, 38.58% 3.09%, 42.87% 1.76%, 47.21% 0.80%, 51.58% 0.21%, 55.93% 0.00%, 60.23% 0.17%, 64.46% 0.72%, 68.58% 1.65%, 72.56% 2.94%, 76.36% 4.59%, 79.97% 6.59%, 83.35% 8.92%, 86.47% 11.56%, 89.31% 14.49%, 91.86% 17.69%, 94.09% 21.14%, 95.98% 24.81%, 97.52% 28.67%, 98.70% 32.70%, 99.51% 36.85%, 99.95% 41.10%, 100.00% 45.43%, 99.67% 49.78%, 98.97% 54.14%, 97.89% 58.47%)",
              zIndex: 6,
            }}
          />
        )}

        {/* Elementy tła leżące nad zdjęciem */}
        <img
          src="/images/CD34overlay.svg"
          alt=""
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '8' }}
        />

        <img
          src="/images/CD34.svg"
          alt=""
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '2' }}
        />
      </div>
    </div>
  );
};
